<template>
  <div class="home_index" :style="detail.bgstyle">
    <div class="home_header">
      <Swipe
        :loop="false"
        :show-indicators="false"
        width="100%"
        height="100%"
        :touchable="false"
        ref="swipeItem"
      >
        <SwipeItem v-for="(item,index) in tabs" :key="index">
          <VanImage :src="item.imgurl" fit="cover" width="100%" height="100%">
            <template v-slot:loading>
              <loading type="spinner" size="20" />
            </template>
            <template v-slot:error>加载失败</template>
          </VanImage>
        </SwipeItem>
      </Swipe>
    </div>
    <template v-if="tabs.length>0">
      <template v-if="tabs.length==1">
        <SportItem :item="currentItem" :detail="detail" :sports_id="sports_id"></SportItem>
      </template>
      <template v-else>
        <Tabs
          type="card"
          swipeable
          class="home_tabs"
          @click="changeCurrentItem"
          v-model="swiperIndex"
          :title-inactive-color="detail.tabstyle[0]['color']"
          :title-active-color="detail.tabstyle[1]['color']"
          :background="detail.tabstyle[0]['background']"
          :color="detail.tabstyle[1]['background']"
        >
          <Tab v-for="(item,index) in tabs" :key="index">
            <div class="home_tab" slot="title">{{item.title}}</div>
            <SportItem
              v-if="currentItem.id==item.id"
              :item="currentItem"
              :detail="detail"
              :sports_id="sports_id"
            ></SportItem>
          </Tab>
        </Tabs>
      </template>
    </template>
  </div>
</template>
<script>
import { Image, Loading, Tab, Tabs, Swipe, SwipeItem } from "vant";

import SportItem from "../Item/Index";
import { mapMutations } from "vuex";

export default {
  components: {
    VanImage: Image,
    Loading,
    Tab,
    Tabs,
    Swipe,
    SportItem,
    SwipeItem,
  },
  props: ["sports_id", "item_id"],
  name: "homeIndex",
  computed: {
    swiperIndex: {
      get() {
        for (let i in this.tabs) {
          if (+this.tabs[+i]["id"] === +this.item_id) {
            return +i;
          }
        }
        return 0;
      },
      set() {},
    },
  },
  data() {
    return {
      currentItem: "",
      tabs: [],
      detail: "",
    };
  },
  watch: {
    item_id(e) {
      this.itemChange();
    },
  },
  methods: {
    ...mapMutations(["setBgColor","toggleShowFill"]),
    itemChange: function () {
       if(this.cf.isEmpty(this.item_id)){
          this.$router.replace({params:{item_id: this.tabs[0]['id']}})
          return ;
       }
       this.currentItem = this.tabs.filter((item) => {
          return +item.id === +this.item_id;
        })[0];
    },
    changeCurrentItem: function (index) {
      this.currentItem = this.tabs[index];
      this.$router.replace({ params: { item_id: this.currentItem.id } });
      this.$refs.swipeItem.swipeTo(index);
    },
    init: function () {
      if(this.sports_id == 39){
        this.$api.user.getUserInfo().then((res) => {
          if (res.status * 1 === 200) {
            let userInfo = res.data;
            if(userInfo.id_number == '' || userInfo.id_number == null || userInfo.id_number == 'null'){
              this.toggleShowFill(true);
                return;
            }
          }
        });
        this.$storage.get('userInfo').then((res)=>{
          
        })
      }
      this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
        duration: 0, // 持续展示 toast
      });
      this.$api.sports.sportsMain(this.sports_id).then(
        (res) => {
          this.tabs = res.data.items;
          let {
            bgstyle,
            id,
            tabstyle,
            introstyle,
            shareconfig,
            title,
          } = res.data;
          try {
            bgstyle = JSON.parse(bgstyle);
            tabstyle = JSON.parse(tabstyle);
            introstyle = JSON.parse(introstyle);
            shareconfig = JSON.parse(shareconfig);
          } catch (e) {
            console.error(e);
          }
          this.detail = { id, bgstyle, tabstyle, introstyle, title };
          //定义 颜色
          this.setBgColor(bgstyle.background);
          this.$storage.set("shareInfo", shareconfig);
          this.itemChange();
          this.$refs.swipeItem.swipeTo(this.swiperIndex);
          if (window.__wxjs_is_wkwebview) {
            //部分ios
            window.scrollTo(0, 1);
          }
          this.$toast.clear();
        },
        (e) => {
          this.$toast.clear();
        }
      );
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
    });
  },
};
</script>
<style lang="less" scoped>
@import url("./index.less");
</style>

